import PlaceholderAutoPlayVideo from './variants/autoPlayVideo/AutoPlayVideo'
import PlaceholderDefault from './variants/default/Default'
import PlaceholderModalVideo from './variants/modalVideo/ModalVideo'
import PlaceholderShopTheLook from './variants/shopTheLook/ShopTheLook'
import PlaceholderShoppableImage from './variants/shoppableImage/ShoppableImage'
import PlaceholderPlaceholders from './variants/placeholders/Placeholders'

import { usePbProps } from '@content/helpers/src/context'

const VARIANT_AUTOPLAY_VIDEO = 'autoplay_video'
const VARIANT_MODAL_VIDEO = 'modal_video'
const VARIANT_SHOPPABLE_IMAGE = 'shoppable_image'
const VARIANT_SHOP_THE_LOOK = 'shop_the_look'
const VARIANT_PLACEHOLDERS = 'placeholders'

type PlaceholderProps = {
    setSelectedPromotionDetails: (details: string) => void
    selectedCategory?: string
}
export default function Placeholder({
    setSelectedPromotionDetails,
    selectedCategory
}: PlaceholderProps) {
    const { copywriting }: any = usePbProps()

    const nonCategoryType = copywriting.selected_variant || copywriting.type
    const foundCategory = copywriting.categories?.find(
        category => category.id === selectedCategory
    )
    const categoryType = foundCategory?.mediaText

    const type = selectedCategory
        ? categoryType?.selected_variant
        : nonCategoryType

    if (type === VARIANT_AUTOPLAY_VIDEO) {
        return (
            <PlaceholderAutoPlayVideo
                onOpenModal={setSelectedPromotionDetails}
            />
        )
    } else if (type === VARIANT_MODAL_VIDEO) {
        return <PlaceholderModalVideo />
    } else if (type === VARIANT_SHOPPABLE_IMAGE) {
        return (
            <PlaceholderShoppableImage
                onOpenModal={setSelectedPromotionDetails}
            />
        )
    } else if (type === VARIANT_SHOP_THE_LOOK) {
        return (
            <PlaceholderShopTheLook
                onOpenModal={setSelectedPromotionDetails}
                content={categoryType}
            />
        )
    } else if (type === VARIANT_PLACEHOLDERS) {
        return (
            <PlaceholderPlaceholders
                onOpenModal={setSelectedPromotionDetails}
            />
        )
    }

    return <PlaceholderDefault onOpenModal={setSelectedPromotionDetails} />
}
